<script setup lang="ts">
import { IonCol, IonIcon, IonRow } from '@ionic/vue';
import { closeCircle, playOutline } from 'ionicons/icons';
import { useRoute, useRouter } from 'vue-router';

import { useStoriesStore } from '@/stores/stories';

const storiesStore = useStoriesStore();
const route = useRoute();
const router = useRouter();

const handleClose = (): void => {
  storiesStore.overlayOpen = false;
  
  // If we're on the /stories route, redirect to /start when closing
  if (route.name === 'stories') {
    router.replace({ name: 'home' });
  }
};
</script>

<template>
  <ion-row class="header-row">
    <ion-col
      size="12"
      class="header-col ion-display-flex ion-align-items-center"
    >
      <div class="icon">
        <ion-icon :icon="playOutline" />
      </div>
      <span class="title">Neuigkeiten</span>
      <button
        type="button"
        class="icon menu-close"
        @click="handleClose"
      >
        <ion-icon :icon="closeCircle" />
      </button>
    </ion-col>
  </ion-row>
</template>

<style lang="less" scoped>
.header-row {
  height: 60px;

  .header-col {
    padding: 10px 13px;
  }
}

.icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-900);
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;

  ion-icon {
    width: 100%;
    height: 100%;
  }
}

.menu-close {
  margin-left: var(--gap-xs);
}

.title {
  flex: 1;
  margin: 0 var(--gap-xs);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
</style>
